export default {
  name:'SlAmapToolbar',
  props:['map'],
  methods:{
    zoomIn(){
      if(this.map) this.map.zoomIn()
    },

    zoomOut(){
      if(this.map) this.map.zoomOut()
    }
  },
  render(){
    return <div class="amap-toolbar" style="background:#fff;box-shadow: 0 2px 2px rgba(0,0,0,.15);border-radius:3px;position: absolute;right: 10px;bottom:10px;">
      <div on-click={this.zoomIn}  class="amap-toolbar__menu" style="padding:8px;" ><Icon size="28" type="md-add" /></div>
      <div on-click={this.zoomOut} class="amap-toolbar__menu" style="padding:8px;border-top:1px solid rgba(0,0,0,.1);"><Icon size="28" type="md-remove" /></div>
    </div>
  }
}